import React, { SVGProps } from "react";
export default function SupCheckCircleFail(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M14.4612 7.16119L7.46119 14.1612M5.16119 11.1612L8.16119 14.1612M1.16119 1.16119L18.8389 18.8389M18.1612 10.1612C18.1612 14.5795 14.5795 18.1612 10.1612 18.1612C5.74292 18.1612 2.16119 14.5795 2.16119 10.1612C2.16119 5.74292 5.74292 2.16119 10.1612 2.16119C14.5795 2.16119 18.1612 5.74292 18.1612 10.1612Z"
        stroke="currentColor"
      />
    </svg>
  );
}
